import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import { VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { List, Row, Cell } from '../../../components/List';
import { setNewInvoiceValue, updateInvoice } from '../../Invoices/actions';
import { selectInvoice, selectNewInvoice } from '../../Invoices/selectors';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { FormField } from '../../../components/FormFields';
import { CompanySelection } from '../../Companies/components/CompanySelection';
import { Loader } from '../../../components/Loader';
import { selectAddressTypes } from '../../Address/selectors';
import { CreditorField } from '../../Invoices/components/IncomingInvoice/FieldsCreditor';
import { INVOICE_DIRECTIONS } from '../../Invoices/constants';
import styles from './CompanyInfoCard.module.css';
import { Calendar } from '../../../components/Icon';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

dayjs.extend(customParseFormat);

const Container = styled.div`
  width: ${props => (props.innerWidth < 768 ? '100%' : '')};
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }

  .status-block {
    width: fit-content;
  }
  .info-card.fixedWeight {
    width: 98%;
    height: 410px;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class CompanyInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.setValue(
      this.props.invoice?.incomingCompanyLabel || this.props.invoice?.outgoingCompanyLabel,
      'creditor_company',
    );
    this.props.types?.map(type => {
      if (!!this.props.company && (type == 'BTW_number' || type == 'customernumber' || type == 'company_from_eu')) {
        this.props.setValue(this.props.company[type], type);
      }
      if (!!this.props.company && type == 'iban') {
        this.props.setValue(this.props.company[type], 'IBAN');
      }
    });
  }

  getFieldValue(fieldName, object) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    if (object == 'invoice') {
      return this.props.invoice[fieldName];
    }

    if (fieldName == 'addresses') {
      return this.props.company?.addresses || [];
    }

    if (fieldName == 'status') {
      return this.props.company?.status;
    }
    return this.props.company[fieldName];
  }

  onEditIncomingCompany() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: true };
    });
  }

  closeIncomingCompanyEdit() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: false, selectedCompanyId: null, selectedCompanyLabel: null };
    });
  }

  onChangeCompanySelection(company) {
    this.setState(prev => {
      return { ...prev, selectedCompanyLabel: company.name ?? company.name ?? '', selectedCompanyId: company.id };
    });
  }

  onUpdate(dto, callback) {
    this.props.update(dto, callback);
  }

  onChangeIncomingCompany() {
    this.setState({ loading: true });
    const companyKey =
      this.props.invoice.direction === INVOICE_DIRECTIONS.INCOMING ? 'incomingCompanyId' : 'outgoingCompanyId';
    return this.onUpdate({ [companyKey]: this.getFieldValue('selectedCompanyId') }, res => {
      if (res.id) {
        ['addresses', 'IBAN', 'BTW_number', 'customernumber', 'company_from_eu'].map(type =>
          this.props.setValue(res[companyKey][type], type),
        );
      }
    });
  }

  renderIncomingCompanyEdit() {
    if (!this.getFieldValue('incomingCompanyEdit', 'invoice')) return '';

    return (
      <ModalComponent title={this.lbl('confirm')} onClose={this.closeIncomingCompanyEdit.bind(this)}>
        {this.state.selectedCompanyId ? (
          <VBox>{this.state.selectedCompanyLabel}</VBox>
        ) : (
          <CompanySelection
            user={{ id: this.getFieldValue('incomingCompanyId', 'invoice') }}
            onSelect={this.onChangeCompanySelection.bind(this)}
          />
        )}
        {this.state.loading && <Loader small />}
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent
            style="ButtonSoftEdit"
            disabled={this.state.loading}
            onClick={this.onChangeIncomingCompany.bind(this)}
          >
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.closeIncomingCompanyEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  datePicker(type) {
    let format = this.props.values[type] == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.props.values[type] && dayjs(this.props.values[type], format);
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          dateFormat="dd-MM-yyyy"
          selected={selected && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
            this.props.setValue(d, type);
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  input(type, disabled) {
    return (
      <div>
        {' '}
        <input
          className="form-control"
          key={this.props.type}
          disabled={disabled}
          value={this.props.values[type]}
          onChange={evt => this.props.setValue(evt.target.value, type)}
        />
      </div>
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const homeTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    const title = this.props.invoice?.direction == INVOICE_DIRECTIONS.INCOMING ? 'creditor' : 'debitor';
    return (
      <Container innerWidth={window.innerWidth}>
        {this.renderIncomingCompanyEdit()}
        <Card className="vehicle-info-card info-card info fixedWeight">
          <h2>{this.lbl(`invoice.details.card.${title}`)}</h2>
          <List>
            <Row onClick={this.onEditIncomingCompany.bind(this)}>
              <Cell>{this.lbl('vehicle.property.creditor_company')}</Cell>
              <Cell>
                <FormField>
                  <input
                    className="form-control"
                    name="name"
                    value={this.props.values.creditor_company ?? ''}
                    onChange={this.onInputChange.bind(this)}
                  />
                </FormField>
              </Cell>
            </Row>
            {this.getFieldValue('addresses') && (
              <Row key={'addresses'}>
                <Cell>{this.lbl(`company.property.address`)}</Cell>
                <Cell>
                  {this.getFieldValue('addresses')?.length &&
                    this.getFieldValue('addresses').map(address =>
                      address.typeId == homeTypeId
                        ? `${address.addressLine1 || ''}; ${address.postcode || ''}; ${address.city || ''} `
                        : '',
                    )}
                </Cell>
              </Row>
            )}

            <CreditorField key="IBAN" type="IBAN" invoice={this.props.invoice} homeAddresId={homeTypeId} />

            <CreditorField key={'BTW_number'} type={'BTW_number'} invoice={this.props.invoice} homeAddresId={homeTypeId} />

            <Row>
              <Cell>{this.lbl('company.property.customernumber')}</Cell>
              <Cell>{this.input('customernumber')}</Cell>
            </Row>
            <Row>
              <Cell>{this.lbl('company.property.company_from_eu')}</Cell>
              <Cell>{this.input('company_from_eu', 'disabled')}</Cell>
            </Row>

            <Row>
              <Cell>{this.lbl('company.property.status')}</Cell>
              <Cell>{this.props.company?.status}</Cell>
            </Row>
          </List>
        </Card>
      </Container>
    );
  }
}

CompanyInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
    values: selectNewInvoice(),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(dto, callback) {
      dispatch(updateInvoice(ownProps.invoice?.id, dto, callback));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyInfoCard = compose(withConnect, withRouter)(CompanyInfoCardComp);
